import type { Admin } from '@core/interview-results-types';

export enum AggregatedEvaluationsSkillStatus {
  AboveRequiredLevel = 'above_required_level',
  AtRequiredLevel = 'at_required_level',
  BelowRequiredLevel = 'below_required_level',
  NoEvaluated = 'no_evaluated',
  NoRequiredLevel = 'no_required_level',
}

export type AggregatedEvaluationsSkillAdmin = Pick<
  Admin,
  'hasAvatar' | 'id' | 'initials' | 'name' | 'photoThumbUrl'
>;

export interface AggregatedEvaluationsSkillSummaryRating {
  expectedProficiencyPosition: number | null;
  ratedProficiencyName: string | null;
  ratedProficiencyPosition: number | null;
  scale: number;
}

export interface AggregatedEvaluationsSkillProficiencyRating extends AggregatedEvaluationsSkillSummaryRating {
  admin: AggregatedEvaluationsSkillAdmin;
  status: AggregatedEvaluationsSkillStatus;
}

export interface AggregatedEvaluationsSkill {
  id: number;
  mixedTeamFeedback: boolean;
  name: string;
  proficiencyRatings: AggregatedEvaluationsSkillProficiencyRating[];
  status: AggregatedEvaluationsSkillStatus;
  summaryRating: AggregatedEvaluationsSkillSummaryRating;
}
